<template>
	<div class="modal modal--registration modal-registration">
		<div class="modal__loading" v-if="loading">
			<loading-spinner />
		</div>
		<div class="modal-registration__form">
			<form-registration :registration="registration" />
		</div>
		<div class="modal-registration__stats">
			<dl>
				<dt>Date Created</dt>
				<dd>{{ registration.dateCreated | date('PPp') }}</dd>
				<dt>Created By</dt>
				<dd>{{ registration.createdByName }}</dd>
				<dt>Date Modified</dt>
				<dd>{{ registration.dateModified | date('PPp') }}</dd>
				<dt>Modified By</dt>
				<dd>{{ registration.modifiedByName }}</dd>
			</dl>
		</div>
	</div>
</template>

<script>
import FormRegistration from '@/components/FormRegistration'
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
	name: 'ModalRegistration',
	components: {
		FormRegistration,
		LoadingSpinner,
	},
	data: () => ({
		loading: false,
	}),
	async mounted() {
		this.loading = true
		await this.$store.dispatch('application/list')
		await this.$store.dispatch('registration/get', this.$route.params.regId)
		this.loading = false
	},
	computed: {
		registration() {
			return this.$store.getters['registration/registration']
		},
	},
}
</script>

<style scoped lang="scss">
.modal-registration {
	display: grid;
	grid-template-columns: 2fr minmax(10rem, 1fr);
	min-width: 70vw;
	width: 100%;

	dl {
		@include modules.fontSize(14px);
		@include modules.gutter('grid-row-gap', 0.5);
		display: grid;
		grid-column-gap: 0;
		grid-template-columns: 1fr auto;
	}

	dd {
		margin: 0;
		text-align: right;
		padding: 0.5rem;

		&:nth-of-type(odd) {
			background-color: modules.color_('background', 'light');
		}
	}

	dt {
		font-weight: 500;
		padding: 0.5rem;
		text-transform: uppercase;

		&:nth-of-type(odd) {
			background-color: modules.color_('background', 'light');
		}
	}
}
</style>
